<template>
    <div class="card-container">
        <common-top-form
            selectShowPower="/depositquantitystatistics/select"
            :model="formModel"
            :submitService="submitService"
            :submitData="submitData"
            @success="onSuccess"
            :show="false"
        >
            <el-form-item label="代理商ID">
                <el-input
                    v-model="formModel.userId"
                    placeholder="请输入"
                ></el-input>
            </el-form-item>
            <el-form-item label="商户号">
                <el-input v-model="formModel.merNo" placeholder="请输入"></el-input>
            </el-form-item>
            <!--<el-form-item label="商户名称">-->
                <!--<el-input v-model="formModel.merNo" placeholder="请输入"></el-input>-->
            <!--</el-form-item>-->
            <el-form-item label="鼓励金ID">
                <el-input v-model="formModel.gljId" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="鼓励金名称">
                <el-input v-model="formModel.gljName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="时间">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    range-separator="至"
                    :clearable="true"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column
                prop="userId"
                label="代理商ID"
                :formatter="formatterTableData"
                min-width="160"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="merNo"
                label="商户号"
                :formatter="formatterTableData"
                min-width="200"
                show-overflow-tooltip
            ></el-table-column>
            <!--<el-table-column-->
                <!--prop="status"-->
                <!--label="商户名称"-->
                <!--:formatter="formatterTableData"-->
                <!--min-width="160"-->
                <!--show-overflow-tooltip-->
            <!--&gt;</el-table-column>-->
            <el-table-column
                prop="gljId"
                label="鼓励金ID"
                min-width="260"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                prop="gljName"
                label="鼓励金名称"
                min-width="260"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                prop="number"
                label="数量"
                min-width="260"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
            <el-table-column
                prop="reward"
                label="分润"
                min-width="260"
                show-overflow-tooltip
                :formatter="formatterTableNumberYuan"
            ></el-table-column>
            <el-table-column
                fixed="right"
                prop="createTime"
                label="创建时间"
                min-width="160"
                show-overflow-tooltip
                :formatter="formatterTableData"
            ></el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTopForm from "components/common/CommonTopForm";
    import CommonTable from "components/common/CommonTable";
    import TransactionService from "service/TransactionService";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "couponinfo",
        components: {
            CommonTopForm,
            CommonTable,
        },
        data() {
            return {
                formModel: {
                    userId: "",
                    merNo: "",
                    gljId: "",
                    gljName: "",
                },
                tableData: [],
                submitService: TransactionService.zxgljprofitinfo,
                params: {},
                page: {},
                isPage: false,
            };
        },
        inject: ["reload"],
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted() {
            this.load();
        },
        computed: {
            submitData() {
                if (this.formModel.time == null || this.formModel.time == "") {
                    this.formModel.time = [];
                }
                const params = {
                    userId: this.formModel.userId,
                    merNo: this.formModel.merNo,
                    gljId: this.formModel.gljId,
                    gljName: this.formModel.gljName,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                if (this.formModel.time.length) {
                    params.startDate = this.formModel.time[0];
                    params.endDate = this.formModel.time[1];
                }
                return params;
            },
            ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
        },
        methods: {
            load() {
                this.formModel = {
                    userId: "",
                    merNo: "",
                    gljId: "",
                    gljName: "",
                };
                this.page = this.$refs.commonTable.page;
                this.getList();
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(
                    this.submitService,
                    this.submitData,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.onSuccess(res);
                            this.isPage = false;
                        });
                    },
                    "信息获取失败"
                );
            },
            onSuccess(res) {
                this.doCheck(res, (res) => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/DepositQuantityStatistics.vue